// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandPointingIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M23.5 11c-.583 0-1.157.145-1.669.424a3.5 3.5 0 0 0-4.83-2.086V5.5a3.5 3.5 0 0 0-7 0v10l-.478-.766a3.5 3.5 0 1 0-6.057 3.516l.584 1.029C8.351 26.86 10.131 30 16 30a11.013 11.013 0 0 0 11-11v-4.5a3.5 3.5 0 0 0-3.5-3.5Zm1.5 8a9.01 9.01 0 0 1-9 9c-4.704 0-5.98-2.25-10.21-9.71l-.586-1.034v-.006a1.5 1.5 0 1 1 2.615-1.47l2.334 3.75A1 1 0 0 0 12 19V5.5a1.5 1.5 0 1 1 3 0V14a1 1 0 1 0 2 0v-1.5a1.5 1.5 0 1 1 3 0V15a1 1 0 1 0 2 0v-.5a1.5 1.5 0 1 1 3 0V19Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
